import script from "./HelloWorld.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelloWorld.vue?vue&type=script&lang=ts&setup=true"

import "./HelloWorld.vue?vue&type=style&index=0&id=301152b7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301152b7"]])

export default __exports__